import { render } from "./property_description.vue?vue&type=template&id=b8d00b56&scoped=true"
import script from "./property_description.vue?vue&type=script&scoped=true&lang=js"
export * from "./property_description.vue?vue&type=script&scoped=true&lang=js"

import "./property_description.vue?vue&type=style&index=0&id=b8d00b56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8d00b56"]])

export default __exports__